module.exports = __webpack_public_path__ + "static/media/On_iphone.67e2c435.png";